<template>
  <div>
    <yx-auto-complete
      :width="width"
      :api="api.queryClassList"
      :placeholder="placeholder"
      :immediate="immediate"
      :keys="{ searchKey: 'className', nameKey: 'className' }"
      :query-params="queryParams"
      :displayFormat="displayFormat"
      @select="(arg) => $emit('select', arg)"
      @clear="() => $emit('clear')"
      ref="yxRef"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '320px',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    immediate: {
      type: Boolean,
      default: true,
    }, // 是否获取焦点立即查询
    queryParams: {
      type: Object,
      default() {
        return {
          classStatus: 0,
        };
      },
    },
  },
  setup() {
    const yxRef = ref(null);
    return {
      yxRef,
      clearField() {
        yxRef.value.clearField();
      },
      setField(str) {
        yxRef.value.setField(str);
      },
      displayFormat(it) {
        // eslint-disable-next-line max-len
        return it.classStatus === 1 ? `<div style="display: inline-block;width: 120px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">${it.className}</div><span style="float:right;color:#a8abb2;font-size: 13px;">(已结班)</span>` : it.className;
      },
    };
  },
});
</script>
